import { useEffect, useState } from "react";
import { fetchAppConfig, type AppRemoteConfig } from "./api/app-config-client";
import { clientEnv } from "./env";
import { moduleRegistry } from "./modules/module.registry";

export function App() {
  const [activeModuleId, setActiveModuleId] = useState(initialModuleId);
  const [remoteConfig, setRemoteConfig] = useState<AppRemoteConfig>();
  const visibleModules = moduleRegistry.filter((module) =>
    module.id !== "omnisynia-ultra" || remoteConfig?.features.omnisyniaUltra?.enabled !== false
  );
  const activeModule = visibleModules.find((module) => module.id === activeModuleId) ?? visibleModules[0];
  const ActiveModule = activeModule?.Component;

  useEffect(() => {
    const controller = new AbortController();
    fetchAppConfig(controller.signal).then(setRemoteConfig).catch(() => undefined);
    return () => controller.abort();
  }, []);

  if (remoteConfig?.maintenance.enabled) {
    return (
      <main className="system-notice maintenance-notice">
        <span className="brand-mark" aria-hidden="true">O</span>
        <p className="eyebrow">OMNISYNIA</p>
        <h1>Estamos mejorando la aplicación</h1>
        <p>Volveremos a estar disponibles en breve.</p>
      </main>
    );
  }

  return (
    <div className="app-frame">
      <aside className="sidebar">
        <div className="brand-lockup">
          <span className="brand-mark" aria-hidden="true">
            O
          </span>
          <div>
            <strong>OMNISYNIA</strong>
            <small>ONE INTELLIGENCE · v1.1</small>
          </div>
        </div>

        <nav aria-label="Módulos OMNISYNIA">
          <p className="nav-title">MÓDULOS</p>
          {visibleModules.map((module) => (
            <button
              className={module.id === activeModuleId ? "module-link active" : "module-link"}
              key={module.id}
              onClick={() => setActiveModuleId(module.id)}
              type="button"
            >
              <span>◈</span>
              <span>
                <strong>{module.displayName}</strong>
                <small>{module.tier === "premium" ? "Premium" : "Core"}</small>
              </span>
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <span className="connection-dot" />
          Backend: {clientEnv.apiBaseUrl}
        </div>
      </aside>

      <main className="workspace">
        {remoteConfig?.version.updateAvailable && (
          <aside className={remoteConfig.version.updateRequired ? "update-banner required" : "update-banner"}>
            <div>
              <strong>{remoteConfig.version.updateRequired ? "Actualización necesaria" : "Actualización disponible"}</strong>
              <span>{remoteConfig.version.message}</span>
            </div>
            {remoteConfig.version.storeUrl && (
              <a href={remoteConfig.version.storeUrl}>Actualizar ahora</a>
            )}
          </aside>
        )}
        <header className="topbar">
          <div>
            <p className="eyebrow">ARQUITECTURA MODULAR</p>
            <h1>Centro creativo</h1>
          </div>
          <span className="version-badge">BUILD {clientEnv.appVersion}</span>
        </header>

        {ActiveModule ? (
          <ActiveModule />
        ) : (
          <section className="empty-state">
            <h2>Módulo no disponible</h2>
            <p>Selecciona un módulo registrado para continuar.</p>
          </section>
        )}
      </main>
    </div>
  );
}

function initialModuleId(): string {
  const accountAction = new URLSearchParams(window.location.search).get("accountAction");
  return accountAction ? "account" : moduleRegistry[0]?.id ?? "";
}

